const Numbers = ({ data }) => (
  <section className="bg-near-white pv6">
    <div className="numbers-grid ml-auto mr-auto mw8">
      <Info
        heading={data.heading}
        subheading={data.subheading}
        paragraph={data.paragraph}
        features={data.features}
      />
      <Stats stats={data.stats} />
    </div>
  </section>
)

export default Numbers

/*
 *
 * General
 * 
 */

import React from 'react'

import LearnMore from '../components/LearnMore'

/*
 *
 * Info
 * 
 */

const Info = ({ heading, subheading, paragraph, features }) => (
  <div className="ph3 md:ph4 lg:ph5">
    <h2 className="subheading mb3">{heading}</h2>
    <h3 className="heading mb4">
      <div className="light-gray">{subheading.gray}</div>
      <div className="gold">{subheading.gold}</div>
    </h3>
    <p className="mb4 measure lh-copy f-lead">{paragraph}</p>
    <Features features={features} />
    <LearnMore className="btn mb5" />
  </div>
)

/*
 *
 * Features
 * 
 */

import FaChevronRight from 'react-icons/lib/fa/chevron-right'
import shortid from 'shortid'

const Features = ({ features }) => (
  <ul className="pb3">
    {features.map(feature => (
      <li key={shortid.generate()} className="flex items-center mb3 lh-copy">
        <FaChevronRight className="flex-none mr2 f-lead gold" />
        {feature}
      </li>
    ))}
  </ul>
)

/*
 *
 * Stats
 * 
 */

const Stats = ({ stats }) => (
  <ul>
    <Stat
      css={{ transform: `translateX(-425px)` }}
      text={stats[0]}
      className="mb4 md:mb5 bg-dark-red w-80"
    />
    <Stat
      css={{ transform: `translateX(-425px)` }}
      text={stats[1]}
      className="mb4 md:mb5 bg-red w-70"
    />
    <Stat
      css={{ transform: `translateX(-425px)` }}
      text={stats[2]}
      className="mb4 md:mb5 bg-light-red w-60"
    />
    <Stat
      css={{ transform: `translateX(-425px)` }}
      text={stats[3]}
      className="bg-washed-red w-90"
    />
  </ul>
)

/*
 *
 * Stat
 * 
 */

import Reveal from '../components/Reveal'

const Stat = ({ css, text, className }) => (
  <Reveal tag="li" css={css} ease="Expo.easeInOut" delay={0} duration={1.5}>
    <div
      className={`flex justify-end items-center ${className} pv2 ph3 h3 lh-title white`}
      style={{
        borderRadius: `0 2rem 2rem 0`
      }}
    >
      <p>{text}</p>
    </div>
  </Reveal>
)



// WEBPACK FOOTER //
// ./src/sections/Numbers.js